import { Directive, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { fromEvent, Subject, Subscription } from 'rxjs';
import { buffer, filter, map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LabelCode, LabelCodeTypeReverseMap } from '../models/label-code.models';

@Directive({
  selector: '[appLabelCodeListener]',
  standalone: true,
})
export class LabelCodeListenerDirective implements OnInit, OnDestroy {
  @Output()
  public labelCodeScanned = new EventEmitter<LabelCode>();

  private subscriptions: Subscription[] = [];
  private enterKey$ = new Subject<void>();
  private allKeys$ = fromEvent<KeyboardEvent>(document, 'keydown');

  private labelCodes$ = this.allKeys$.pipe(
    map((e) => e.key),
    map((k) => (k === 'Enter' && this.enterKey$.next(), k)),
    buffer(this.enterKey$),
    map((b) => b.filter((k) => /^[0-9A-Z $%*+-./:]$/.test(k)).join('')),
    map((s) => /HTTPS:\/\/ARK.WINE\/([A-Z])\/([A-Z0-9]{19})$/.exec(s)),
    filter((r) => !!r),
    map((r) => new LabelCode(LabelCodeTypeReverseMap[r![1]], r![2])),
  );

  ngOnInit(): void {
    this.subscriptions.push(this.labelCodes$.subscribe((x) => this.labelCodeScanned.emit(x)));
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }
}
